<template>
  <div v-cloak class="container">

    <div class="Bread">
        <Bread :list="breadList" />
    </div>

    <div class="Survey-detail pa-20 ma-b-40 bg-fff">
      <h1 class="t-center" v-if="detail.Title">
        {{ detail.Title }}
      </h1>
      <div class="ma-t-20 pa-b-20 c-666" v-if="detail.Remark">
        {{ detail.Remark }}
      </div>
      <div class="flex f-between c-666 pa-b-20">
        <div class="">发布时间：{{ detail.InsertTime }}</div>
        <div class="">
          有效时间：{{ detail.StartTime }} - {{ detail.EndTime }}
        </div>
        <div></div>
      </div>
      <div class="sd-b-b-1"></div>
      <div class="ma-t-20" v-html="detail.Summary" v-if="detail.Summary"></div>

      <div v-if="detail.Question && formData.length > 0" class="ma-t-50">
        <div
          v-for="(item, index) in detail.Question"
          :key="index"
          class="ma-t-60"
          :id="'item' + index"
        >
          <div>
            <span class="bold">{{ index + 1 }}.{{ item.Title }}</span>
            <span class="c-red"> {{ item.IsRequired ? "*" : "" }}</span>
            <span class="c-999">
              {{
                item.Type == 1 ? "(单选）" : item.Type == 2 ? "（多选）" : ""
              }}
              {{
                (item.Limit != 0) & (item.Type == 2)
                  ? "（至少选择" + item.Limit + "项）"
                  : ""
              }}
              {{
                (item.Limit != 0) & (item.Type == 3 || item.Type == 4)
                  ? "（至少输入" + item.Limit + "个字）"
                  : ""
              }}
            </span>
          </div>
          <div class="">
            <!-- 选择题 单选-->
            <div v-if="item.Type == 2" class="">
              <div v-for="(it, i) in item.Item" :key="i">
                <div
                  @click="checkItem(index, it.Id)"
                  class="ma-l-20 pa-t-20 c-pointer w-s-pre-line flex f-center"
                >
                  <div class="checkbox">
                    <div class="checkbox-active" v-if="(formData[index].answerId + '').includes(it.Id)"></div>
                  </div>
                  <div class="flex1">
                    {{ String.fromCharCode(i + 65) }} . {{ it.Item }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 选择题 多选-->
            <div v-if="item.Type == 1" class="">
              <div v-for="(it, i) in item.Item" :key="i">
                <div
                  @click="checkItem(index, it.Id)"
                  class="ma-l-20 pa-t-20 c-pointer w-s-pre-line flex f-center"
                >
                  <div class="checkbox  b-r-50">
                    <div class="checkbox-active  b-r-50" v-if="(formData[index].answerId + '').includes(it.Id)"></div>
                  </div>
                 <div class="flex1">
                   {{ String.fromCharCode(i + 65) }} . {{ it.Item }}
                 </div>
                </div>
              </div>
            </div>
            <!-- 填空题目 -->
            <div v-if="item.Type == 3 || item.Type == 4" class="pa-tb-10 pa-l-20">
              <el-input
                v-if="formData.length > 0"
                v-model="formData[index].answerText"
                placeholder="请把答案填写"
                :type="item.Type == 4 ? 'textarea' : 'text'"
                @input="textChange(index)"
                class=""
                rows="5"
              ></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="t-center pa-tb-30">
        <div class="btn-submit" @click="Submit()">提交</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" spaced>
.sd-b-b-1 {
  border-bottom: 0.6px dashed rgb(165, 165, 165);
  position: absolute;
  width: 100%;
  left: 0;
}
.Survey-detail {
  .checkbox {
    width: 10px;
    height: 10px;
    background: #ffffff;
    border: 1px solid #7d7d7d;
    margin-right: 10px;
    padding: 2px;
    margin-top: 2px;
  }
  .checkbox-active {
      width: 100%;
      height: 100%;
      background: #00479d;
    }

  padding: 20px 70px 20px 70px;
  min-height: 800px;
  position: relative;
  .w-s-pre-line {
    white-space: pre-line;
  }
  .sd-active {
    font-weight: bold;
    color: #ee0000;
  }
  .c-666 {
    color: #666;
  }
  .Survey-detail {
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
    background: #ffffff;
  }
  .btn-submit {
    padding: 10px 60px;
    background: #234775;
    color: #fff;
    display: inline-block;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
<script>
import { getSurveyDetail, postSurvey } from "../api.js";
var _this;
export default {
  name: "Survey-detail",
  components: {},
  data() {
    return {
      Id: 0, //题目id
      detail: {}, //题目详情
      formData: [], //每个题目的答案
      StartTime: "",
      isFinish: false, //是否完成提交
      breadList: [{ name: "问卷调研", path: "/Survey" },{ name: "调研详情", path: "/Survey-detail" }],
    };
  },

  created() {
    _this = this;
    _this.init();
  },
  filters: {},
  computed: {},
  //离开组件
  beforeRouteLeave(to, from, next) {
    if (_this.isFinish) {
      next();
    } else {
      this.$confirm("您确定离开吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {});
    }
  },

  destroyed() {},
  watch: {
    $route(to) {
      if (to.name == "Survey-detail") {
        this.init();
      }
    },
  },
  methods: {
    init() {
      _this.Id = _this.$route.query.id || _this.Id;
      _this.StartTime = handleTime();
      _this.SurveyDetail();
    },
    //提交
    Submit() {
      //必填非空验证
      for (let index = 0; index < _this.detail.Question.length; index++) {
        const element = _this.detail.Question[index];
        const item = _this.formData[index];
        if (element.IsRequired) {
          if ((element.Type == 1 || element.Type == 2) && item.answerId == "") {
            _this.$message.error("第" + (index + 1) + "题未选择答案");
            _this.scrolls("item" + index);
            return;
          }
          if (
            (element.Type == 3 || element.Type == 4) &&
            item.answerText == ""
          ) {
            _this.$message.error("第" + (index + 1) + "题未填写答案");
            _this.scrolls("item" + index);

            return;
          }
        }

        //规则验证，选项个数、文字长度
        if (
          element.Limit != 0 &&
          element.Type == 2 &&
          element.Limit > item.answerId.split(",").length
        ) {
          _this.$message.error(
            "第" + (index + 1) + "题至少选择" + element.Limit + "个选项"
          );
          _this.scrolls("item" + index);
          return;
        }

        if (
          element.Limit != 0 &&
          (element.Type == 3 || element.Type == 4) &&
          item.answerText.length < element.Limit
        ) {
          _this.$message.error(
            "第" + (index + 1) + "题至少输入" + element.Limit + "个字"
          );
          _this.scrolls("item" + index);

          return;
        }
      }
      let data = new FormData();
      data = {
        StartTime: _this.StartTime,
        EndTime: handleTime(),
        SurveyId: _this.Id,
        Item: _this.formData,
      };
      console.log(data);

      postSurvey(data).then((res) => {
        if (res.data.Code != 0) {
          _this.$message({
            message: res.data.Message,
            type: "warning",
          });
          return;
        }
        _this.isFinish = true;
        _this.$message({
          message: "提交成功",
          type: "success",
          duration: 1000,
        });
        setTimeout(() => {
          _this.$router.go(-1);
        }, 1000);
      });
    },
    //选择题，选择
    checkItem(index, answerId) {
      let isReadio = _this.detail.Question[index].Type == 1;
      if (isReadio) {
        _this.formData[index].answerId = answerId;
        _this.formData[index].isDone = true;
      } else {
        let answer = _this.formData[index].answerId.split(",");
        if (_this.formData[index].answerId == "") {
          answer = [];
        } else {
          answer = _this.formData[index].answerId.split(",");
        }

        let i = answer.indexOf(answerId);
        if (i == -1) {
          answer.push(answerId);
          _this.formData[index].isDone = true;
        } else {
          _this.formData[index].isDone = false;

          answer.splice(i, 1);
        }
        _this.formData[index].answerId = answer.join(",");
      }
    },
    //填空题，填写
    textChange(index) {
      console.log(_this.formData[index].answerText);
      if (_this.formData[index].answerText) {
        _this.formData[index].isDone = true;
      } else {
        _this.formData[index].isDone = false;
      }
    },
    //初始化formData
    initFormData() {
      for (let index = 0; index < _this.detail.Question.length; index++) {
        const element = _this.detail.Question[index];
        this.$set(_this.formData, index, {
          isDone: false,
          questionId: element.Id,
          answerId: "",
          answerText: "",
        });
      }
    },
    //获取题目
    SurveyDetail() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "#0000000",
      });
      let token = localStorage.getItem("AccessToken");
      let datas = {
        id: this.Id,
        token: token,
        source: "pc",
      };

      getSurveyDetail(datas)
        .then((res) => {
          if (res.data.Code == 0) {
            //数据处理，如果至少输入字数Limit不等于0，且是否必填IsRequired等于false，那么修改IsRequired为true。
            for (let index = 0; index < res.data.Data.Question.length; index++) {
              const element = res.data.Data.Question[index];
              if(element.Limit!=0 && element.IsRequired==false){
                res.data.Data.Question[index].IsRequired=true
              }
            }
            
            _this.detail = res.data.Data;
            _this.initFormData();
            loading.close();
          } else {
            loading.close();

            this.$alert(res.data.Message, "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: () => {
                this.$router.go(-1);
              },
            });
          }
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },

    //点击滚动到制定位置
    scrolls(id) {
      this.$el.querySelector(`#${id}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center", //区域中间
      });
    },
  },
};

// 将时间戳格式化
function handleTime(time = new Date()) {
  var datetime = new Date(); // 如果不是时间戳 就在这儿这作为参数传入
  datetime.setTime(time);
  var year = datetime.getFullYear();
  var month = datetime.getMonth() + 1;
  var date = datetime.getDate();
  var hour = datetime.getHours();
  if (hour <= 9) {
    hour = "0" + hour;
  }
  var minute = datetime.getMinutes();
  if (minute <= 9) {
    minute = "0" + minute;
  }
  var second = datetime.getSeconds();
  if (second <= 9) {
    second = "0" + second;
  }
  // var mseconds = datetime.getMilliseconds();
  return (
    year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second
  ); //+"."+mseconds;
}
</script>


